module.exports = __webpack_public_path__ + "static/media/standard_chartered.4e248502.svg";